/**
 * @module tree/removed
 */

/**
 * @typedef {Element|Text} Target
 */


import resolvable from '@mailobj-browser/front/js/utils/resolvable.js'
import never from '@mailobj-browser/front/js/utils/never.js'

const observers = new WeakMap()
const resolvers = new WeakMap()
const nodes = new Set()
const ticks = []

const options = {
  childList: true,
  subtree: true
}

const find = removedNode => {
  const removed = []
  
  for (const node of nodes) {
    if (removedNode?.contains(node)) {
      removed.push(node)
    }
  }
  
  return removed
}

const callback = records => {
  for (const { removedNodes } of records) {
    for (const removedNode of removedNodes) {
      for (const node of find(removedNode)) {
        for (const resolve of resolvers.get(node)) {
          resolve(true)
        }
        
        nodes.delete(node)
        resolvers.delete(node)
      }
    }
  }
}

const observing = (ownerDocument, options) => {
  if (!observers.has(ownerDocument)) {
    const { defaultView, documentElement } = ownerDocument
    const { MutationObserver } = defaultView
    const observer = new MutationObserver(callback)

    observers.set(ownerDocument, observer)
    observer.observe(documentElement, options)
  }

  return observers.get(ownerDocument)
}

export const tick = promise => {
  ticks.push(promise)

  queueMicrotask(async () => {
    await promise
    ticks.splice(ticks.indexOf(promise), 1)
  })
}

/**
 * Awaits the target to be removed from the DOM tree
 * @param {Target} target The node to be removed
 * @param {?Promise<*>} abort The abortion promise
 * @return {Promise<Target>}
 */
export default async (target, abort = never) => {
  const { ownerDocument } = target
  const [removed, { resolve }] = resolvable()
  const promise = Promise.resolve(ticks.at(-1))

  if (!nodes.has(target)) {
    observing(ownerDocument, options)
    nodes.add(target)
    resolvers.set(target, new Set())
  }

  const resolver = resolvers.get(target)

  resolver.add(resolve)

  //await Promise.race([abort, removed, promise])

  //if (!await unresolved(promise) && ownerDocument.contains(target)) {
    await Promise.race([abort, removed])
  //}

  resolver.delete(resolve)

  return target
}
